export type FundAward = {
  previousYearAmount?: unknown;
  previousYearRecipients?: unknown;
  currentYearAmount?: unknown;
};

export type Fund = {
  id?: string | number;
  _tempId?: string | number;
  _status?: string;
  specialFundId?: string | number;
  name?: string;
  awardingType?: string;
  awards?: FundAward[];
  [key: string]: unknown;
};

export type FundCandidate = {
  id?: string | number;
  name?: string;
  awards?: FundAward[];
  [key: string]: unknown;
};

export interface FundsFilterValues {
  source: string[];
  type: string[];
  instAid: boolean | null;
  totalAid: boolean | null;
}

export const EMPTY_FUNDS_FILTERS: FundsFilterValues = {
  source: [],
  type: [],
  instAid: null,
  totalAid: null,
};
